<a
  class="{{ link.styleClass }} {{ styleClass }}"
  [attr.href]="link.isExternal ? link.url : '#'"
  [attr.target]="link.isExternal ? '_blank' : '_self'"
  [attr.rel]="link.isExternal ? 'noopener noreferrer' : ''"
  (click)="onClick($event)"
>
  <ng-content>{{ link.linkName }}</ng-content>
</a>
